export default "__VITE_PUBLIC_ASSET__8430e8b5__"